import { VisibilityOff } from "@mui/icons-material";
import { FileUploaderRipik } from "./FileUploaderRipik";
import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import FileViewer from "./FileViewer";

// type Props = {
//   input_objects: MonthlyTitles | MasterTitles;
//   update_input_objects: (key_to_be_updated: string, file: File) => void;
//   stage_name: string;
// };

const InputTable = ({ input_objects, update_input_objects, stage_name }) => {
  return (
    <Box>
      <Box className="mb-4">
        <Typography color="text.secondary" fontSize="16px" fontWeight="500" letterSpacing="0.15">
          {stage_name}
        </Typography>
      </Box>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow
              sx={{
                bgcolor: "#A6C4DC",
                textTransform: "capitalize",
              }}
            >
              <TableCell>S. no</TableCell>
              <TableCell>File Name</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>File</TableCell>
              <TableCell>View</TableCell>
              {/* <TableCell>Status</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(input_objects).filter(([key, value]) => { return value.visible; }).map(([key, value], idx) => (
              <TableRow
                key={`${idx}-${key}`}
                sx={{
                  border: "1px solid #ebebeb",
                  textTransform: "capitalize",
                }}
              >
                <TableCell>{idx + 1}</TableCell>
                <TableCell className="uppercase">{value.display_name.split("_").join(" ")}</TableCell>
                <TableCell>{value.category}</TableCell>
                <TableCell>
                  <FileUploaderRipik
                    key={`${key}-${idx}-file_uploader`}
                    file={value.file}
                    name={key}
                    file_update_function={(file) => {
                      update_input_objects(key, file);
                    }}
                  />
                </TableCell>
                <TableCell>
                  {value?.columns && value?.table_data ? (
                    <FileViewer
                      columns={value.columns}
                      table_data={value.table_data}
                      name={value.form_data_name.split("_").join(" ")}
                    />
                  ) : (
                    <IconButton disabled={true}>
                      <VisibilityOff />
                    </IconButton>
                  )}
                </TableCell>
                {/* <TableCell>{value.status ? <CheckCircle /> : <Cancel />}</TableCell> */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default InputTable;
